import { render, staticRenderFns } from "./SupportTable.vue?vue&type=template&id=292dcb52&scoped=true&lang=pug&"
import script from "./SupportTable.vue?vue&type=script&lang=ts&"
export * from "./SupportTable.vue?vue&type=script&lang=ts&"
import style0 from "./SupportTable.vue?vue&type=style&index=0&id=292dcb52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292dcb52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VBtn,VCheckbox})
